import { ApiResponse } from "../utils/api/ApiProps";
import api from "../utils/api";

export interface SourceOption {
  uuid: string;
  opt_name: string;
  opt_value?: string;
  active?: boolean;
}

export interface SourceColumnData {
  uuid: string;
  col_name: string;
  col_label: string;
  col_type: string;
  options: SourceOption[];
}

export const getSourceOptions = async (): Promise<ApiResponse<{ columns: SourceColumnData[] }>> => {
  const searchParams = new URLSearchParams();

  // Search for the source column
  searchParams.append("search_term", "source");

  // Include options in the response
  searchParams.append("include", "options");

  // Get all records
  searchParams.append("all", "true");

  const response = await api.get<{ columns: SourceColumnData[] }>(
    `/columns/?${searchParams.toString()}`
  );

  return response;
};
